// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__92c4D","header":"ReportDetails_header__TK1L7","title":"ReportDetails_title__23hkw","left":"ReportDetails_left__1wQbg"};